import { PlannedTwinIDUpdateMode } from '../config/constants';
import client from './Client';

export async function updatePlannedTwinIDs(
  csv: string,
  tenant: string,
  projectCode: string,
  assetType: string,
  planID: string,
  mode: PlannedTwinIDUpdateMode,
  action: 'plan' | 'apply',
) {
  const upsert = mode === 'upsert';
  const result = await client.server.post(
    `/scratch/project/${tenant}/${projectCode}/plan?`
    + `action=${action}&upsertMode=${upsert}`,
    { csv, assetType, planID },
  );
  return result.data.value;
}

export async function fetchPlannedTwinIDs(
  tenant: string,
  projectCode: string,
  assetType: string,
  planID: string,
) {
  const encodedAT = encodeURIComponent(assetType);
  const result = await client.server.get(
    `/scratch/project/${tenant}/${projectCode}/plan?`
    + `assetType=${encodedAT}&planID=${planID}&includePlannedStatusDates=${1}`,
  );
  return result.data.value;
}
